import React, { useEffect, useState } from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import HSlider from "../Components/HSlider";
import Aos from "aos";
import { getLateralHiring } from "../Common/apis";
import Loader from "../Loader/Loader";

function LateralHirning() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  console.log(data);
  useEffect(() => {
    Aos.init({
      duration: 1000, // animation duration in ms
      once: true // animate only once
    });
  }, []);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const res = await getLateralHiring();
        setData(res.data || []);
      } catch (err) {
        console.error("Error fetching services:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchServices();
  }, []);
  return (
    <>
      <div className="main-div2">
        <Navbar />
        {loading && <Loader />}
        <div className="grid xl:grid-cols-2 md:grid-cols-1 grid-cols-1 md:gap-0 gap-[20px] justify-between overflow-hidden items-start md:pt-[163px] pt-[100px]">
          <div>
            <div className="flex flex-col gap-[12px] pt-[34px]">
              <img
                data-aos="fade-right"
                src="/assets/services/item9.svg"
                className="relative left-[-70px] md:h-[88px] h-[70px] max-w-[445px] w-full"
                alt=""
              />
              <img
                data-aos="fade-right"
                src="/assets/services/item10.svg"
                className="relative left-[-70px] md:h-[88px] h-[70px] max-w-[537px] w-full"
                alt=""
              />
            </div>
            <div className="flex justify-center md:pt-[45px] pt-0 md:pl-[0px] pl-[20px] md:pr-0 pr-[20px]">
              <img
                data-aos="flip-up"
                src="/assets/services/item11.svg"
                alt=""
              />
            </div>
          </div>
          <div>
            <div
              data-aos="flip-up"
              className="max-w-[624px] md:mx-auto w-full bg-[#6953A3] rounded-[20px] border-[8px] border-[#FDD60D] p-[30px]"
            >
              <h6 className="max-w-[424px] w-full font-sans font-[500] text-[31px] leading-[42px] text-[#FFFFFF] pb-[20px]">
                What is Lateral Hiring Training?
              </h6>
              <p className="font-[400] font-sans text-[16px] leading-[26px] text-[#FFFFFF]">
                GISUL is a trusted partner for organizations seeking to enhance
                their workforce with cutting-edge, hands-on, and
                industry-aligned training programs. With a strong emphasis on
                practical knowledge and skill application, GISUL empowers
                professionals and teams to perform, adapt, and grow in dynamic
                work environments.
              </p>
            </div>
            <div className="pt-[50px] pb-[150px] h-slider">
              <HSlider data={data} />
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}

export default LateralHirning;
